import { t } from '@lingui/macro';

import { Actions, Page, PageHeader, FilterContainer, PanelContainer } from '../../page-framework';
import Link from '../../links/Link';
import { JumpSettings as JumpSettingsIcon } from '../../icon/Icons';
import { useIsAdminUser } from '../../../stores/SessionStore';
import { AccessPointFilter, TimeRangeFilter, useAccessPoint, accessPointFilterId } from '../../filters';
import { useSummarizedFilterStateById } from '../../../stores/FilterStateStore';
import { LAYOUT_WIDTH } from '../../page-framework/panel-container/PanelContainer';

import { AccessPointStatusBreakoutPanel, AccessPointRadioListPanel, AccessPointPropertiesPanel } from '../../panels';

export const pageId = 'access-point-detail';

export default function AccessPointDetailPage() {
    const accessPoint = useAccessPoint();
    const [summarized] = useSummarizedFilterStateById(accessPointFilterId);
    const title = summarized?.value;
    const [isAdminUser] = useIsAdminUser();

    return (
        <Page id={pageId}>
            <PageHeader
                title={title}
                titleActions={
                    accessPoint &&
                    !accessPoint.deleted &&
                    isAdminUser && (
                        <Actions>
                            <Link
                                to={`/admin/monitored-infrastructure/${accessPoint?.uuid}`}
                                title={t`Edit access point configuration`}
                            >
                                <JumpSettingsIcon fontSize="small" />
                            </Link>
                        </Actions>
                    )
                }
            >
                <FilterContainer>
                    <TimeRangeFilter required />
                    <AccessPointFilter required />
                </FilterContainer>
            </PageHeader>
            <PanelContainer>
                <AccessPointStatusBreakoutPanel width={LAYOUT_WIDTH.FULL} title={t`Status`} />
                <AccessPointRadioListPanel width={LAYOUT_WIDTH.FULL} title={t`Radios`} />
                <AccessPointPropertiesPanel width={LAYOUT_WIDTH.FULL} title={t`Properties`} />
            </PanelContainer>
        </Page>
    );
}
